import {
  AGE,
  AGE_MAP,
  contentTypeOptions,
  GENDER,
  GENDER_MAP,
  platformOptions,
  PUBLIC_FILTER_TYPE,
  RACE,
  RACE_MAP,
} from '@/entities/public-filter/constants';
import { getCountryName } from '@/shared/utils/get-country-name';
import { getLanguageName } from '@/shared/utils/get-language-name';

export const getPublicFilterDisplayValue = (
  filterType: PUBLIC_FILTER_TYPE,
  value: string | number,
): {
  label: string;
  Icon?: React.ElementType;
} => {
  switch (filterType) {
    case PUBLIC_FILTER_TYPE.PROMOTION_TYPE:
      return {
        label: contentTypeOptions.find((option) => option.value === value)?.label ?? '',
        Icon: contentTypeOptions.find((option) => option.value === value)?.icon,
      };
    case PUBLIC_FILTER_TYPE.PLATFORM:
      return {
        label: platformOptions.find((option) => option.value === value)?.label ?? '',
        Icon: platformOptions.find((option) => option.value === value)?.icon,
      };
    case PUBLIC_FILTER_TYPE.GENDER:
      return {
        label: GENDER_MAP.get(value as GENDER) ?? '',
      };
    case PUBLIC_FILTER_TYPE.RACE:
      return {
        label: RACE_MAP.get(value as RACE) ?? '',
      };
    case PUBLIC_FILTER_TYPE.AGE:
      return {
        label: AGE_MAP.get(value as AGE) ?? '',
      };
    case PUBLIC_FILTER_TYPE.LOCATION:
      return {
        label: getCountryName(value as string) ?? '',
      };
    case PUBLIC_FILTER_TYPE.LANGUAGE:
      return {
        label: getLanguageName(value as string) ?? '',
      };
    default:
      return {
        label: value as string,
      };
  }
};
